import React from 'react'
import PropTypes from 'prop-types'
import { Field } from 'redux-form'
import { Input } from 'components/common/FormElements/Input'
import * as UI from './FormStyles'

const Name = ({ form, ...props }) =>
  <React.Fragment>
    <UI.Row>
      <UI.Cell>
        <Field
          { ...props }
          { ...form }
          full
          static
          component={ Input } />
      </UI.Cell>
    </UI.Row>
  </React.Fragment>

Name.propTypes = {
  form: PropTypes.shape({
    firstName: PropTypes.shape()
  })
}

export default Name
